import { render, staticRenderFns } from "./ProRiskSynthesisFilter.vue?vue&type=template&id=67b10bca&"
import script from "./ProRiskSynthesisFilter.vue?vue&type=script&lang=ts&"
export * from "./ProRiskSynthesisFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports